import { useCallback } from 'react';

import useTranslationStore from '../../../store/translations';
import translate from '../../../utils/translate';

import type { TranslateProviderName } from './data/labelCategoryMapper';

/**
 * The labels feature's one way to turn a provider's wire name into text:
 * `provider.name` is a translation KEY (`{provider.facebook}`), and translations
 * live in the app's translation store. The repository's content rows and the
 * Channels & Accounts pick list both take their translator from here, and both
 * decide what counts as "no name" through `toProviderDisplayName`.
 *
 * Its own module, not a repository export: UI tests replace the repository
 * wholesale with `vi.mock`, and the pick list must keep naming providers there.
 */
export function useProviderNameTranslator(): TranslateProviderName {
  const translations = useTranslationStore((state) => state.translations);
  return useCallback((name: string) => translate(translations, name), [translations]);
}
